import type { TrackUsage } from '@qlk/shared';
import { History } from 'lucide-react';
import { Link } from 'react-router-dom';

import { EmptyState, KhoiMuc } from '../../../ui/index.js';
import { ngayGioVn } from './dinhDang.js';

export interface SuDungGanDayProps {
  dong: TrackUsage[];
  dangTai: boolean;
  loi?: string | null;
}

/** Danh sách "Sử dụng gần đây" dưới bảng kho nhạc. */
export function SuDungGanDay({ dong, dangTai, loi }: SuDungGanDayProps) {
  return (
    <KhoiMuc tieuDe="Sử dụng gần đây" satLe>
      {dangTai && <p className="px-6 py-5 text-co-ban text-chu-phu">Đang tải lịch sử dùng…</p>}

      {loi && (
        <p role="alert" className="px-6 py-5 text-co-ban text-bad-chu">
          {loi}
        </p>
      )}

      {!dangTai && !loi && dong.length === 0 && (
        <EmptyState
          icon={History}
          title="Chưa có lượt dùng nào"
          description="Khi module Sản xuất nội dung gán nhạc cho video, lượt dùng sẽ hiện ở đây."
        />
      )}

      {dong.length > 0 && (
        <ul className="divide-y divide-vien">
          {dong.map((u) => (
            <li key={u.id} className="flex flex-wrap items-center justify-between gap-2 px-6 py-4">
              <div className="min-w-0">
                <Link
                  to={`/kho-nhac/${u.trackId}`}
                  className="text-co-ban font-semibold text-chu hover:text-nhan"
                >
                  {u.trackTitle}
                </Link>
                <p className="truncate text-phu text-chu-mo">
                  {u.channelName} · {u.videoRef}
                </p>
              </div>
              <span className="so-lieu text-phu text-chu-mo">{ngayGioVn(u.usedAt)}</span>
            </li>
          ))}
        </ul>
      )}
    </KhoiMuc>
  );
}
